import React, { useEffect, useState } from "react";
import Layout from "../../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../../elements/list/list";
import { Container } from "../../../common/layout/styels";
import ViewFiles from "../../documents/ViewFiles";
import { useSelector } from "react-redux";
import { getData } from "../../../../../backend/api";
// import NationalityChart from "./chart";
const BirthdayReport = (props) => {
  const { t } = useTranslation();

  const user = useSelector((state)=> state.login)

  const [userCountNation, setUserCountNation] = useState([]);

  const [attributes] = useState([
    {
      type: "number",
      placeholder: "personalNumber",
      name: "personalNumber",
      tab: "generalInfo",
      validation: "",
      default: user?.data?.highestPersonnelNumber,
      label: "personalNumber",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "--",
      name: "fullName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "fullName",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "enterEmail",
      tab: "generalInfo",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: false,
      upload: true,
      view: true,
      tag: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "select",
      name: "department",
      tab: "generalInfo",
      validation: "",
      showItem: "title",
      default: "",
      label: "department",
      required: false,
      filterType: "multiSelect",
      view: true,
      tag: false,
      add: false,
      update: false,
      apiType: "API",
      selectApi: "department/select",
    },
    {
      type: "multiSelect",
      placeholder: "select",
      tab: "generalInfo",
      name: "place",
      validation: "",
      showItem: "title",
      default: "",
      label: "place",
      required: false,
      filterType: "multiSelect",
      view: true,
      tag: false,
      add: false,
      update: false,
      apiType: "API",
      selectApi: "place/select",
    },
    {
      type: "date",
      placeholder: "selectBirthDate",
      name: "birthDate",
      tab: "personalData",
      validation: "date",
      default: "empty",
      label: "birthDate",
      required: false,
      view: true,
      tag: false,
      add: false,
      update: false,
    },
    
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("birthday")} - PersoBase`;
  }, [t]);
  
  const transformData = (data, t) => {
  const monthLabels = [];
  const counts = new Array(12).fill(0);

  data?.data?.forEach((monthData) => {
    const { month, count } = monthData;
    const monthIndex = month - 1;

    // Create translated label for month
    monthLabels[monthIndex] = `${t(`month-${month}`)} ${data.year}`;

    // Fill counts array
    counts[monthIndex] = count;
  });

  return {
    series: [
      {
        name: t("birthdayCount"),
        data: counts,
      },
    ],
    categories: monthLabels,
  };
};


  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container style={{flexDirection:'column'}} className="noshadow">
      <ListTable bulkUplaod={false} {...props} api={`user`} itemTitle={`fullName`} shortName={`birthday`} viewDetails={false} addPrivilege={false} delPrivilege={false} updatePrivilege={false} selectPrivilege={false} attributes={attributes} formMode="double" moreOptions={false} popUpUsingId={false} chart={'report/birthday'} datefilter={false} transformData={transformData} ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(BirthdayReport);
